module.exports = __webpack_public_path__ + "img/PL08717.4dcc8789.png";